import { FC, Fragment } from "react";
import { useTranslation } from "react-i18next";

import { IProductionChainPreviewStep } from "@ryde/shared";

import {
  GeneralInfoTextBlock,
  GeneralInfoTitleBlock,
  ProductionPreviewSummaryStyled,
} from "../production-preview.styled";
import { useChainStepSummaryItems } from "./production-chain-step-content.hook";
import {
  ProductionChainStepBlock,
  ProductionChainStepContentStyled,
} from "./production-chain-step-content.styled";

interface IProductionChainStepContentProps {
  chainStep: IProductionChainPreviewStep;
}

export const ProductionChainStepContent: FC<
  IProductionChainStepContentProps
> = ({ chainStep }) => {
  const { t } = useTranslation();
  const summaryItems = useChainStepSummaryItems(chainStep);

  return (
    <ProductionChainStepContentStyled>
      <ProductionChainStepBlock>
        <GeneralInfoTitleBlock>
          {t("booking.generalInfo.productionType")}
        </GeneralInfoTitleBlock>
        <GeneralInfoTextBlock>
          {t(`booking.generalInfo.${chainStep.data.action}`)}
          {chainStep.data.productionType?.length
            ? ` (${chainStep.data.productionType.join(", ")})`
            : ""}
        </GeneralInfoTextBlock>
      </ProductionChainStepBlock>
      <ProductionChainStepBlock>
        <GeneralInfoTitleBlock>
          {t("booking.generalInfo.summary")}
        </GeneralInfoTitleBlock>
        {summaryItems.length > 0 && (
          <ProductionPreviewSummaryStyled>
            {summaryItems.map(item => (
              <Fragment key={item.label}>
                <div className="summary_item_title">{t(item.label)}</div>
                <div className="summary_item_info">{item.value}</div>
              </Fragment>
            ))}
          </ProductionPreviewSummaryStyled>
        )}
      </ProductionChainStepBlock>
    </ProductionChainStepContentStyled>
  );
};
